import { useState, useMemo } from 'react';
import { Product, categories } from '@/mocks/products';
import ProductCard from './ProductCard';

interface ProductGridProps {
  products: Product[];
  title?: string;
  showFilter?: boolean;
  limit?: number;
}

export default function ProductGrid({ products, title, showFilter = true, limit }: ProductGridProps) {
  const [activeCategory, setActiveCategory] = useState<string>('All');

  const displayedProducts = useMemo(() => {
    let filtered = activeCategory === 'All'
      ? products
      : products.filter((p) => p.category === activeCategory);
    if (limit && limit > 0) {
      filtered = filtered.slice(0, limit);
    }
    return filtered;
  }, [products, activeCategory, limit]);

  return (
    <div className="w-full">
      {title && (
        <h2 className="text-2xl md:text-3xl font-bold text-warm-900 mb-6 md:mb-8">
          {title}
        </h2>
      )}

      {showFilter && (
        <div className="flex flex-wrap gap-2 mb-6 md:mb-8">
          <button
            onClick={() => setActiveCategory('All')}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
              activeCategory === 'All'
                ? 'bg-brand-500 text-white'
                : 'bg-warm-100 text-warm-700 hover:bg-warm-200'
            }`}
          >
            All
          </button>
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                activeCategory === cat
                  ? 'bg-brand-500 text-white'
                  : 'bg-warm-100 text-warm-700 hover:bg-warm-200'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>
      )}

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
        {displayedProducts.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>

      {displayedProducts.length === 0 && (
        <div className="text-center py-16 text-warm-600">
          No products found in this category.
        </div>
      )}
    </div>
  );
}